import React from 'react';
import { HashLink as Link } from 'react-router-hash-link';


const TableOfContentRow = ({ id, text, ...rest }) => {

    return <li {...rest} className="list-link-container">
                <Link to={"\#" + id} className="nav-link-dark list-link">
                            {text}
                </ Link>
           </li>
};

const TableOfContent = ({ contentLinks, ...rest }) => {
    return <div {...rest} className="card opinion-card__spacing object-card">
                <div className="opinion-card-title title-text">
                    Tabla de Contenido
                </div>
            <div className="opinion-card-body">
                    <ul>
                        {contentLinks.map(cl => (
                            <TableOfContentRow
                                id={cl.id}
                                text={cl.textContent}
                            />
                        ))}
                    </ul>
            </div>
        </div>
};

export default TableOfContent;